export default "__VITE_ASSET__C1zH_84k__"